enum BringOwnBagEnum {
  CUSTOMER_BAG = 'Customer must bring their own bag',
  CUSTOMER_ENCOURAGE_BAG = 'Customer is encouraged to bring their own bag',
  BUSINESS_BAG = 'Customer will be given a complimentary bag',
}

export default BringOwnBagEnum
